<template>
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M77.9748 39.8084C78.3234 40.1464 78.3319 40.703 77.9939 41.0515L61.9885 57.5572L55.6054 50.3401C55.2837 49.9764 55.3178 49.4208 55.6815 49.0991C56.0452 48.7775 56.6008 48.8115 56.9224 49.1752L62.0478 54.9703L76.7317 39.8275C77.0697 39.479 77.6262 39.4704 77.9748 39.8084Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.2193 39.7978L15.3732 40.0364C12.9721 40.7134 11.537 42.0878 10.9137 44.1684C10.7669 44.6583 10.6368 45.5762 10.548 46.9905L10.4928 47.8679L8.73804 47.7576L8.79318 46.8802C8.88251 45.4586 9.01974 44.3637 9.22939 43.6638C10.045 40.941 11.9853 39.1648 14.8961 38.3441L15.7422 38.1055L16.2193 39.7978ZM22.6723 38.0542L23.5237 38.2734C26.4756 39.0337 28.4826 40.7399 29.3712 43.4071C29.6204 44.1552 29.7827 45.3375 29.8883 46.8751L29.9485 47.7522L28.1944 47.8726L28.1342 46.9956C28.029 45.4642 27.8753 44.4796 27.7031 43.9629C27.0308 41.9448 25.5493 40.6107 23.0852 39.9761L22.2338 39.7569L22.6723 38.0542Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.3407 30.7692C16.9131 30.7692 14.9451 32.7372 14.9451 35.1648C14.9451 37.5925 16.9131 39.5604 19.3407 39.5604C21.7683 39.5604 23.7363 37.5925 23.7363 35.1648C23.7363 32.7372 21.7683 30.7692 19.3407 30.7692ZM13.1869 35.1648C13.1869 31.7662 15.942 29.011 19.3407 29.011C22.7394 29.011 25.4946 31.7662 25.4946 35.1648C25.4946 38.5635 22.7394 41.3187 19.3407 41.3187C15.942 41.3187 13.1869 38.5635 13.1869 35.1648Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.15391 20.2198C4.69733 20.2198 3.51654 21.4006 3.51654 22.8572V56.2637C3.51654 57.7203 4.69733 58.9011 6.15391 58.9011H58.9012C59.3867 58.9011 59.7803 59.2947 59.7803 59.7802C59.7803 60.2658 59.3867 60.6593 58.9012 60.6593H6.15391C3.72628 60.6593 1.7583 58.6914 1.7583 56.2637V22.8572C1.7583 20.4295 3.72628 18.4615 6.15391 18.4615H64.1759C66.6035 18.4615 68.5715 20.4295 68.5715 22.8572V42.0879C68.5715 42.5734 68.1779 42.967 67.6924 42.967C67.2068 42.967 66.8132 42.5734 66.8132 42.0879V22.8572C66.8132 21.4006 65.6325 20.2198 64.1759 20.2198H6.15391Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.1319 27.2528H10.5495V48.3517H28.1319V27.2528ZM8.79127 25.4945V50.1099H29.8902V25.4945H8.79127Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2858 27.2528H60.6594V30.7692H34.2858V27.2528Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2858 33.4066H50.11V35.1648H34.2858V33.4066Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2858 37.8022H53.6264V39.5604H34.2858V37.8022Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2858 46.5934H51.8682V48.3517H34.2858V46.5934Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2858 42.1978H48.3517V43.9561H34.2858V42.1978Z" fill="#05070F" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'IdCardIcon',
};
</script>
